
class Helper {
    constructor() {

    }

    getErrorMessage(data) {
        var errorMessage = "";

        // Check if error data exists and has expected structure
        if (!data || !data.responseException) {
            return "An unexpected error occurred";
        }

        if (data.responseException.exceptionMessage && data.responseException.exceptionMessage.title) {
            errorMessage = data.responseException.exceptionMessage.title;

            // Handle validation errors with user-friendly formatting
            if (errorMessage == "One or more validation errors occurred." && data.responseException.exceptionMessage.errors) {
                const errors = data.responseException.exceptionMessage.errors;
                const errorList = [];

                // Parse each validation error
                for (const [field, messages] of Object.entries(errors)) {
                    // Clean up field name (remove $. prefix and make it readable)
                    const fieldName = field.replace(/^\$\./, '').replace(/\./g, ' > ');

                    // Get the first error message for this field
                    if (Array.isArray(messages) && messages.length > 0) {
                        let message = messages[0];

                        // Simplify common JSON conversion errors
                        if (message.includes("could not be converted")) {
                            message = "Please enter a valid numeric value";
                        }

                        errorList.push(`• ${fieldName}: ${message}`);
                    }
                }

                if (errorList.length > 0) {
                    errorMessage = "Please fix the following errors:\n\n" + errorList.join("\n");
                } else {
                    errorMessage = "Please check your input and try again.";
                }
            }
        } else if (data.responseException.exceptionMessage) {
            errorMessage = data.responseException.exceptionMessage;
        } else {
            errorMessage = "An error occurred";
        }
        return errorMessage;
    }

}

export default Helper;